const gender = [
  { label: "Male", value: "1" },
  { label: "Female", value: "2" },
  { label: "Prefer not to say", value: "3" },
];

export default gender;